import { CompteDetention } from 'src/app/api/model/compte-detention.model';
import { TypeChangementEnum } from '../../constantes/type-changement.enum';

export class StateModifier {
  private constructor(
    public readonly type: string,
    public readonly compteDetention?: CompteDetention
  ) {}
  public static coordonnees(): StateModifier {
    return new StateModifier(TypeChangementEnum.COORDONNEES);
  }
  public static courriel(compteDetention?: CompteDetention): StateModifier {
    return new StateModifier(TypeChangementEnum.COURRIEL, compteDetention);
  }
  public static telephone(): StateModifier {
    return new StateModifier(TypeChangementEnum.TELEPHONE);
  }
}
